function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Evented from './Evented';
var CHANNEL_PASSTHROUGH = ['connected', 'failed', 'reconnecting', 'up', 'down', 'switching', 'error', 'message', 'destroy'];
/**
 * Abstracts the shared/common IChannel for a unique client
 * so that events can easily be tracked and unbound when needed
 */

var UniqueChannelInstance = /*#__PURE__*/function (_Evented) {
  _inheritsLoose(UniqueChannelInstance, _Evented);

  function UniqueChannelInstance(channel) {
    var _this;

    _this = _Evented.call(this) || this;
    _this.channel = channel;
    CHANNEL_PASSTHROUGH.forEach(function (eventName) {
      _this.listenTo(_this.channel, eventName, function () {
        var _this2;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        (_this2 = _this).emit.apply(_this2, [eventName].concat(args));
      });
    });

    _this.off = function (event, handler) {
      if (event) {
        if (handler) {
          _this.removeListener(event, handler);
        } else {
          _this.removeAllListeners(event);
        }
      } else {
        _this.removeAllListeners();
      }

      return _assertThisInitialized(_this);
    };

    _this.fireInitialConnectionEvents();

    return _this;
  }

  var _proto = UniqueChannelInstance.prototype;

  _proto.unsubscribe = function unsubscribe() {
    if (this.channel) {
      this.channel.unsubscribe();
      this.stopListening(this.channel);
      this.removeAllListeners();
      delete this.channel;
    }
  } // The channel may already be connected if we re-use it
  // so fire initial connection events if that was the case
  ;

  _proto.fireInitialConnectionEvents = function fireInitialConnectionEvents() {
    var _this3 = this;

    if (this.channel.isConnected) {
      setTimeout(function () {
        if (_this3.channel && _this3.channel.isConnected) {
          _this3.emit('connected');

          _this3.emit('up');
        } else {
          _this3.emit('failed', 'channel removed');
        }
      }, 0);
    }
  };

  return UniqueChannelInstance;
}(Evented);

export { UniqueChannelInstance as default };